import { useI18n } from "../i18n/I18nProvider";

/** Page numbers to show: first, last, current ±1, with `null` marking gaps. */
export function pageWindow(page: number, totalPages: number): (number | null)[] {
  const pages = new Set([1, totalPages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= totalPages));
  const sorted = [...pages].sort((a, b) => a - b);
  return sorted.flatMap((p, i) => (i > 0 && p - sorted[i - 1] > 1 ? [null, p] : [p]));
}

export function Pagination({ page, totalPages, onPage }: { page: number; totalPages: number; onPage: (page: number) => void }) {
  const { t } = useI18n();
  if (totalPages <= 1) return null;
  return (
    <nav className="pagination" aria-label={t("pagination.label")}>
      <button type="button" className="page-btn" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        ‹ {t("pagination.prev")}
      </button>
      {pageWindow(page, totalPages).map((p, i) =>
        p === null ? (
          <span key={`gap-${i}`} className="page-gap">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            className={p === page ? "page-btn is-current" : "page-btn"}
            aria-current={p === page ? "page" : undefined}
            aria-label={t("pagination.page", { page: p })}
            onClick={() => onPage(p)}
          >
            {p}
          </button>
        ),
      )}
      <button type="button" className="page-btn" disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
        {t("pagination.next")} ›
      </button>
    </nav>
  );
}
